import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { fetchAttractions, createAttraction, updateAttraction, deleteAttraction } from "../../API/touristAttractionApi"; // Adjust the path as necessary
import { FaEdit, FaTrash } from "react-icons/fa"; // Import icons
import "./Atraction.css"; // Ensure to have your custom styles here

const TouristAttraction = () => {
  const [placeName, setPlaceName] = useState('');
  const [description, setDescription] = useState('');
  const [files, setFiles] = useState([]); // Updated to handle multiple files
  const [touristCenters, setTouristCenters] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [editId, setEditId] = useState(null);

  useEffect(() => {
    const loadAttractions = async () => {
      try {
        const data = await fetchAttractions();
        setTouristCenters(data);
      } catch (error) {
        console.error("Error loading attractions:", error);
      }
    };

    loadAttractions();
  }, []);

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files); // Get all selected files
    setFiles(selectedFiles); // Update the state with the array of files
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append('name', placeName);
    formData.append('description', description);

    if (files.length > 0) {
        files.forEach((file) => {
            formData.append('images', file); // Append each file
        });
    }

    console.log('Submitting:', Array.from(formData.entries())); // For debugging

    try {
        if (isEditing) {
            console.log('Updating attraction with ID:', editId.trim());
            await updateAttraction(editId.trim(), formData);
            setIsEditing(false);
            setEditId(null);
        } else {
            await createAttraction(formData); // Create attraction
        }

        // Reset form fields
        setPlaceName('');
        setDescription('');
        setFiles([]); // Reset files state

        // Fetch updated attractions list
        const updatedAttractions = await fetchAttractions();
        setTouristCenters(updatedAttractions);
    } catch (error) {
        console.error('Error saving attraction:', error.response ? error.response.data : error.message);
    }
};

  const handleEdit = (center) => {
    setIsEditing(true);
    setEditId(center._id);
    setPlaceName(center.name);
    setDescription(center.description);
    setFiles([]); // Reset file for editing
  };

  const handleDelete = async (id) => {
    try {
      await deleteAttraction(id);
      setTouristCenters(touristCenters.filter(center => center._id !== id));
    } catch (error) {
      console.error("Error deleting attraction:", error.message);
    }
  };

  return (
    <div className="container mt-5">
      <h2 className="text-center mb-3">Tourist Attraction</h2>
      <div className="row">
        {/* Form Section */}
        <div className="col-12 col-md-6">
          <form className="card p-4 mb-4 shadow-box" onSubmit={handleSubmit}>
            <div className="form-group mb-3">
              <label htmlFor="placeName">Place Name</label>
              <input
                type="text"
                className="form-control"
                id="placeName"
                placeholder="Enter place name"
                value={placeName}
                onChange={(e) => setPlaceName(e.target.value)}
                required
              />
            </div>
            <div className="form-group mb-3">
              <label htmlFor="description">Description</label>
              <textarea
                className="form-control"
                id="description"
                rows="4"
                placeholder="Enter description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                required
              ></textarea>
            </div>
             <div className="form-group mb-3">
              <label htmlFor="file">Files</label>
              <input
                type="file"
                className="form-control-file"
                id="file"
                onChange={handleFileChange}
                multiple // Allow multiple file uploads
              />
            </div>
            <button type="submit" className="btn Submit-Btn">
              {isEditing ? 'Update' : 'Submit'}
            </button>
          </form>
        </div>

        {/* Tourist Attraction List Section */}
        <div className="col-12 col-md-6">
          <div className="card p-4 old-news-container">
            <h5 className="mb-3">Tourist Attractions</h5>
            <div className="news-list">
              {touristCenters.length === 0 ? (
                <p>No attractions found.</p>
              ) : (
                touristCenters.map(center => (
                  <div key={center._id} className="news-item mb-3">
                    <h6 className="news-title">{center.name}</h6>
                    <p className="news-content">{center.description.substring(0, 50)}...</p>

                    {/* Image Gallery Section */}
                    {center.images && center.images.length > 0 && (
                      <div className="image-gallery mb-2">
                          {center.images.map((image, index) => {
                              const imageUrl = `http://192.168.56.1:5001/uploads/attraction/${image}`; // Correctly construct URL
                              return (
                                  <img
                                      key={index}
                                      src={imageUrl}
                                      alt="Attraction Image"
                                      className="img-fluid rounded"
                                      style={{ maxHeight: '200px', objectFit: 'cover', marginRight: '5px' }}
                                  />
                              );
                          })}
                      </div>
                  )}
                    <div className="news-footer d-flex justify-content-between align-items-center">
                      <small className="text-muted date">
                        {new Date(center.createdAt).toLocaleDateString()}
                      </small>
                      <div className="icon-group">
                        <FaEdit
                          className="icon-button text-primary me-2"
                          onClick={() => handleEdit(center)}
                        />
                        <FaTrash
                          className="icon-button text-danger"
                          onClick={() => handleDelete(center._id)}
                        />
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default TouristAttraction;